import LocalUrlMaker from "../lib/LocalUrlMaker";
import {camelizeKeysDeep} from "../ReduxStore/Helpers/transformObject";
import {readCachedLocalStorage, STORAGE_CACHE_KEYS, writeCachedLocalStorage} from "../Session/cachedLocalStorage";
import {getParams} from "../lib/params";

const STORAGE_KEY = STORAGE_CACHE_KEYS.PAGE_TRIGGERS;


/**
 * Fetch page triggers from local storage or the back-end.
 * Stash them in cachedLocalStorage.
 *
 *
 * @param callback
 * @returns {Promise<* | void>|Promise<unknown>}
 */
export function getPageTriggers({params} = {}) {
  params ||= getParams(params);

  const reset = !!params['RESET'];

  // if reset is true don't read from storage, fetch it
  const triggers = reset ? null : readPageTriggersFromStorage();
  if (triggers) {
    return new Promise((resolve, reject) => {
      resolve(triggers);
    });
  }

  const url = LocalUrlMaker.prefixedPath("/page_triggers.json");

  return fetch(url)
    .then(r => r.json())
    .then(data => normalizeAndStash(data))
    .catch(err => console.error(`error fetching ${url}: ${err}`));
}

function readPageTriggersFromStorage() {
  const data = readCachedLocalStorage(STORAGE_KEY);

  return data?.pageTriggers;
}

function normalizeAndStash(data) {
  data = camelizeKeysDeep(data);
  writeCachedLocalStorage(STORAGE_KEY, data,
    {expiresIn: 3600});

  return data.pageTriggers;
}
